<template>
  <LinkCard
    :icon="['fal', 'puzzle-piece']"
    :image="thumbnail"
    :title="$path('internalName', value)"
    :badges="badges"
    :to="$attrs.to || defaultLink"
  />
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    value: Object,
  },
  computed: {
    thumbnail() {
      const src = getCoverThumbnail(this.$path('value.media.cover') || [])
      if (!src) return

      return { src, alt: this.value.name }
    },
    badges() {
      return [
        this.value.demo ? { theme: 'warning', value: this.$t('demo') } : null,
        this.value.isArchived ? { theme: 'warning', value: this.$t('archived') } : null,
      ].filter(Boolean)
    },
    defaultLink() {
      if (!this.$store.getters.hasAccess('residentialTemplates'))
        return { name: 'residential-template-leads', params: { reference: this.value.id } }

      return { name: 'residential-template-edit', params: { id: this.value.id } }
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
